// Prime de transport par défaut selon le pays (Yros/Support#39). Même table
// que le backend (excopaie, TRANSPORT_PREMIUM_BY_COUNTRY) : les pays absents
// prennent le montant générique.
const TRANSPORT_PREMIUM_BY_COUNTRY = { ci: 30000 };
const TRANSPORT_PREMIUM_FALLBACK = 26000;

export const getDefaultTransportPremium = (country) =>
    TRANSPORT_PREMIUM_BY_COUNTRY[(country || '').toLowerCase()] ?? TRANSPORT_PREMIUM_FALLBACK;
